import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=47430161&scoped=true"
var script = {}
import style0 from "./Cards.vue?vue&type=style&index=0&id=47430161&prod&scoped=true&lang=css"
import style1 from "./Cards.vue?vue&type=style&index=1&id=47430161&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47430161",
  null
  
)

export default component.exports